
import logo from "../../assets/icons/mocionLogo.svg";


import ShareModalContent from "./ShareModalContent";
type Props = {
  eventId?: number;
  inviteLink: {
    link: string;
    id: number;
    type: string;
  };
};

function ShareModal({ inviteLink }: Props) {

  return (
    <div className="flex flex-col gap-4 px-6 py-5 text-primary dark:text-white">
      <div className="flex flex-col justify-center items-center gap-4 text-center ">
        <img
          loading="lazy"
          width={200}
          height={200}
          src={logo}
          alt="mocion-logo"
          className="pb-4"
        />

        <h2 className="text-primary dark:text-white">Share with Community</h2>
        <ShareModalContent inviteLink={inviteLink} />
      </div>
    </div>
  );
}

export default ShareModal;
